import { StyledInput } from "./TimeInput.styles";

const TimeInput = ({ isDisabled, error, ...props }) => {
  return (
    <StyledInput type="time" isDisabled={isDisabled} error={error} {...props} />
  );
};

export default TimeInput;
